import moment from 'moment'
const _time = value => {
  return moment(value).format('YYYY-MM-DD')
}
const _timeDate = value => {
  return moment(value).date()
}
const _getActivityType = value => {
  let type
  switch (value) {
    case 1:
      type = '跨店铺促销'
      break
    case 1 << 1:
      type = '跨店铺优惠券'
      break
    case 1 << 2:
      type = '跨店铺广告'
      break
    case 1 << 3:
      type = '店铺礼包'
      break
    case 1 << 4:
      type = '店铺banner图'
      break
    case 1 << 5:
      type = '内容营销'
      break
    case 1 << 6:
      type = '高级广告语'
      break
  }
  return type
}
export default () => {
  return {
    time: _time,
    getActivityType: _getActivityType,
    timeDate: _timeDate
  }
}



// WEBPACK FOOTER //
// ./src/filters/filter.js